import type {OrderOptions} from '@github-ui/dashboard-sorting-dropdown/SortingDropdown'
import {PersonIcon, RepoPushIcon, StarIcon, TypographyIcon} from '@primer/octicons-react'

export const defaultSortingOptions: Record<string, OrderOptions> = {
  updated: {label: 'Last pushed', defaultDirection: 'desc', icon: RepoPushIcon},
  name: {label: 'Name', defaultDirection: 'asc', icon: TypographyIcon},
  stars: {label: 'Stars', defaultDirection: 'desc', icon: StarIcon},
}

export const sortingOptionsWithRelevance: Record<string, OrderOptions> = {
  relevance: {label: 'Relevance', defaultDirection: 'desc', icon: PersonIcon},
  ...defaultSortingOptions,
}
